import React from "react";
import "../assets/styles.css";
import AboutUsImage from "../assets/pad-pro-about-us-banner.png";

export default function AboutUsSectionA() {
  return (
    <div>
      <section className="relative h-80 sm:h-96 lg:h-[450px] xl:h-[500px] overflow-hidden" data-aos="fade-up" data-aos-duration="1000">
        {/* Background Image */}
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${AboutUsImage})` }}
        >
          {/* Enhanced gradient overlay for better text readability */}
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30 sm:from-black/60 sm:via-black/40 sm:to-transparent"></div>
        </div>
        
        {/* Content */}
        <div className="relative z-10 h-full flex items-center justify-center">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-5xl mx-auto text-center">
              
              {/* Main Title - Enhanced responsive sizing */}
              <h1 className="text-3xl xs:text-4xl sm:text-5xl lg:text-6xl xl:text-7xl text-green-400 mb-3 sm:mb-4 lg:mb-6 newsreader leading-tight">
                About Us
              </h1>
              
              {/* Subtitle - Enhanced responsive sizing and layout */}
              <div className="text-white font-medium newsreader leading-tight">
                <p className="text-lg xs:text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl">
                  Empowering adults with disabilities
                </p>
                <p className="text-lg xs:text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl">
                  through care and community.
                </p>
              </div>
              
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}